import { render, staticRenderFns } from "./Statuses.vue?vue&type=template&id=62a27b54&"
import script from "./Statuses.vue?vue&type=script&lang=js&"
export * from "./Statuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports